import React from 'react'
import AdminNavbar from "../Navbars/AdminNavbar.js";
import Sidebar from "../Sidebar/Sidebar";
import { SuperAdminApis } from '../../apis/superAdminApi';
import { useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { convertUTCDateToLocalDate } from '../Reusable/functions';
import AdminSidebar from '../Sidebar/AdminSidebar';
//@ts-ignore
import Modal from 'react-awesome-modal';
import { SvgElement, icontypesEnum } from '../assets/svgElement';
import { ToastContainer, toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Oval } from 'react-loader-spinner';
function ManageInvoice() {


  let [invoiceModal, setInvoiceModal] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const [userLists, setUserList] = React.useState<any>([]);
  const [searchText, setSearchText] = React.useState('');
  const [from, setFrom] = React.useState('');
  const [to, setTo] = React.useState('');

  const [fromDate, setFromDate] = React.useState('');
  const [toDate, setToDate] = React.useState('');
  const [userEmail, setUserEmail] = React.useState('');

  const [sending, setSending] = React.useState<boolean>(false);
  const [downloading, setDownloading] = React.useState<boolean>(false);
  // Set once an invoice has been emailed, so the modal can prompt for the copy.
  const [sentTo, setSentTo] = React.useState('');

  // ── Manual payments ─────────────────────────────────────────
  // Invoices settled outside Paystack are ticked here and marked paid in bulk.
  const userLoginData = useSelector((state: any) => state.data.login.value);
  const canMarkPaid = React.useMemo(() => {
    if (userLoginData?.data?.role === 'admin') return true;
    try {
      const perms = userLoginData?.data?.permissions ? JSON.parse(userLoginData.data.permissions) : [];
      return Array.isArray(perms) && perms.includes('can_manage_invoice');
    } catch {
      return false;
    }
  }, [userLoginData]);

  const [selectedIds, setSelectedIds] = React.useState<number[]>([]);
  const [markPaidModal, setMarkPaidModal] = React.useState<boolean>(false);
  const [marking, setMarking] = React.useState<boolean>(false);
  const [paymentChannel, setPaymentChannel] = React.useState('Bank Transfer');
  const [paymentReference, setPaymentReference] = React.useState('');
  const [paymentNote, setPaymentNote] = React.useState('');

  const rows: any[] = userLists?.data || [];
  // Already-settled invoices can't be re-marked, so they aren't selectable.
  const payableRows = rows.filter((row: any) => row?.payment_status !== 'successful');
  const allPayableSelected = payableRows.length > 0 && payableRows.every((row: any) => selectedIds.includes(row.id));

  const selectedTotal = rows
    .filter((row: any) => selectedIds.includes(row.id))
    .reduce((sum: number, row: any) => sum + Number(row?.amount || 0), 0);

  const toggleRow = (id: number) => {
    setSelectedIds((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);
  };

  const toggleAll = () => {
    setSelectedIds(allPayableSelected ? [] : payableRows.map((row: any) => row.id));
  };

  const openMarkPaidModal = () => {
    if (selectedIds.length === 0) {
      toast.warn('Select at least one invoice first');
      return;
    }
    setMarkPaidModal(true);
  };

  const closeMarkPaidModal = () => {
    setMarkPaidModal(false);
    setPaymentReference('');
    setPaymentNote('');
  };

  const markSelectedAsPaid = React.useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setMarking(true);
      try {
        const response: any = await SuperAdminApis.bulkMarkInvoicesPaid({
          invoice_ids: selectedIds,
          payment_channel: paymentChannel,
          payment_reference: paymentReference,
          payment_note: paymentNote,
        });

        const payload = response?.data;

        if (!payload?.status) {
          toast.error(payload?.message || 'Could not mark the invoices as paid');
          return;
        }

        const result = payload.data;
        toast.success(
          `${result.invoices_updated} invoice(s) paid · ${result.shipments_verified} shipment(s) verified · ${result.shipment_numbers_generated} shipment number(s) generated`
        );

        // A failed partner call still leaves the payment recorded, so it has to be
        // called out rather than swallowed by the success toast.
        if (result.shipment_number_failures?.length) {
          toast.warn(
            `${result.shipment_number_failures.length} shipment(s) could not get a shipment number — verify them manually`,
            { autoClose: 8000 }
          );
        }
        setSelectedIds([]);
        closeMarkPaidModal();
        paginator('');
      } catch (error: any) {
        toast.error(error?.response?.data?.message || 'Failed to mark the invoices as paid');
      } finally {
        setMarking(false);
      }
    }, [selectedIds, paymentChannel, paymentReference, paymentNote]);


  React.useEffect(() => {
    const query: any = {
      search: searchText,
      from: from,
      to: to
    };
    SuperAdminApis.getAllInvoices('', query).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setUserList(response?.data?.data)
          console?.log(response?.data?.data)
        }
      }
    ).catch(function (error) {
      // handle error

    })
  }, []);



  const paginator = React.useCallback(
    (value: any) => {
      //   setLoader(true);
      let value2 = '';
      if (value !== null) {
        value2 = value;
      } else {
        value2 = ''
      }
      const query: any = {
        search: searchText,
        from: from,
        to: to
      };

      SuperAdminApis.getAllInvoices(value2, query).then(
        (response: AxiosResponse<any>) => {
          if (response?.data) {
            setUserList(response?.data?.data)
            console?.log(response?.data?.data)
          }
        }
      ).catch(function (error) {
        console.log(error.response.data);
      })

    }, [userLists, searchText, from, to]);


  const openInvoiceModal = () => {
    setSentTo('');
    setInvoiceModal(true);
  };

  const closeInvoiceModal = () => {
    setSentTo('');
    setInvoiceModal(false);
  };


  const generateInvoice = React.useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {

      e.preventDefault();
      setSending(true);
      const query: any = {
        date_from: fromDate,
        date_to: toDate,
        email: userEmail
      };

      SuperAdminApis.sendInvoice(query).then(
        (response: AxiosResponse<any>) => {
          if (response?.data?.status) {
            toast.success("Invoice Sent to Customer")
            // Modal stays open so the same invoice can be downloaded straight away.
            setSentTo(userEmail)
          } else {
            toast.error("Invoice not valid for the date range")
          }
        }
      ).catch(function (error) {
        toast.error("Could not send the invoice")
      }).finally(() => {
        setSending(false)
      })

    }, [fromDate, toDate, userEmail]);


  /**
   * Downloads the exact PDF that is attached to the customer's invoice email —
   * rendered server-side so both copies are the same document. This endpoint
   * never sends a mail or creates a payment link.
   */
  const downloadInvoice = React.useCallback(
    async () => {
      if (!fromDate || !toDate || !userEmail) {
        toast.warn("Pick a date range and enter the customer's email first")
        return;
      }

      setDownloading(true);
      try {
        const response: any = await SuperAdminApis.downloadInvoicePdf({
          date_from: fromDate,
          date_to: toDate,
          email: userEmail
        });

        const blob = response?.data;

        if (!blob || !(blob instanceof Blob)) {
          toast.error("Could not build the invoice")
          return;
        }

        // Errors come back as JSON even though we asked for a blob.
        if (blob.type && blob.type.includes('json')) {
          const message = JSON.parse(await blob.text())?.message;
          toast.error(message || "Could not build the invoice")
          return;
        }

        const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `invoice-${userEmail}-${fromDate}-${toDate}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        toast.success("Invoice downloaded")
      } catch (error) {
        toast.error("Failed to download the invoice")
      } finally {
        setDownloading(false);
      }

    }, [fromDate, toDate, userEmail]);




  return (
    <>
      <AdminSidebar title="Invoice" />
      <div className="relative md:ml-64 bg-[#FAFAFA] ">
        <AdminNavbar title="Invoice" />
        <div className=' lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>

          <div className='grid grid-cols-1 md:flex justify-between gap-3'>
            <div>
              <h3 className='text-[15px] text-[#1C1C1C] font-semibold'>Invoice&nbsp;List</h3>

            </div>
            <span></span><span></span> <span></span><span></span> <span></span><span></span>

            {/* <div> */}


            {/* <button className='bg-[#E04343] text-white text-[14px] px-[12px] py-[8px] rounded-[10px]'>+ Add Customers</button> */}
            {/* <div className='flex justify-end '> */}
            {/* <div className=" lg:ml-auto mr-3 flex justify-end gap-3"> */}
            <div className=" flex justify-start w-full gap-2">
              <h2 className='text-sm '>From: &nbsp;</h2>
              <span className='w-full'>
                <input type="date" onClick={() => paginator('')} onChange={e => setFrom(e.target.value)} placeholder='' className=" border border-gray-300 text-gray-500 text-sm rounded-md  w-full pl-4 py-1 px-4  " required />
              </span>

            </div>

            <div className=" flex justify-start w-full">
              <span className='text-sm'>To: &nbsp;</span>
              <span className='w-full'>
                <input type="date" onClick={() => paginator('')} onChange={e => setTo(e.target.value)} placeholder='' className=" border border-gray-300 text-gray-500 text-sm rounded-md  w-full pl-4 px-4 py-1  " required />
              </span>

            </div>

            <div className="relative flex w-full ">
              {/* <div className="absolute inset-y-0 right-2 flex items-center pl-3 pointer-events-none">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="#9da4aa" d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0a5.5 5.5 0 0 1 11 0z" /></svg>
              </div> */}

              <span className='w-full'>
                <input type="text" onClick={() => paginator('')} onChange={e => setSearchText(e.target.value)} placeholder='search...' className=" border border-gray-300 text-gray-500 text-sm rounded-md  w-full pl-4 px-4 py-1  " required />
              </span>

            </div>

            <div className='flex justify-between'>
              <div className='mt-0.5 ml-2'><button type='button' onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => paginator('')} className={"font-normal text-white bg-[#E04343] px-3 py-0.5 rounded-md"}>Search</button> </div>
             <span className='md:hidden'>
             <div className='mt-0.5 ml-2 flex  md-hidden'><button type='button' onClick={openInvoiceModal} className={"font-normal text-white bg-[#E04343] px-3 py-0.5 rounded-md"}>Generate&nbsp;Invoice</button> </div>

             </span>
              
            </div>


          </div>

          <div className='md:flex justify-end  hidden'>
          <div className='mt-0.5 ml-2'><button type='button' onClick={openInvoiceModal} className={"font-normal text-white bg-[#E04343] px-3 py-0.5 rounded-md"}>Generate&nbsp;Invoice</button> </div>

          </div>


          {/* Bulk action bar — only while something is ticked */}
          {canMarkPaid && selectedIds.length > 0 && (
            <div className='flex flex-wrap items-center justify-between gap-3 bg-[#19213D] text-white rounded-[8px] px-4 py-3 mt-3'>
              <div className='text-[13px]'>
                <b>{selectedIds.length}</b> invoice{selectedIds.length === 1 ? '' : 's'} selected
                <span className='text-[#B7BDD1]'> · </span>
                <b>{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(selectedTotal)}</b>
              </div>
              <div className='flex gap-2'>
                <button
                  type='button'
                  onClick={() => setSelectedIds([])}
                  className='text-[13px] px-3 py-1.5 rounded-md border border-[#4B5573] hover:bg-[#2A3352]'
                >
                  Clear
                </button>
                <button
                  type='button'
                  onClick={openMarkPaidModal}
                  className='text-[13px] font-semibold px-4 py-1.5 rounded-md bg-[#E04343] hover:bg-[#c93a3a]'
                >
                  Mark as Paid
                </button>
              </div>
            </div>
          )}

          <div className="relative overflow-x-auto">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-separate border-spacing-y-3">
              <thead className="text-[12px] text-[#808080] bg-[#FAFAFA] ">
                <tr>

                  {canMarkPaid && (
                    <th scope="col" className="px-2 py-2">
                      <input
                        type="checkbox"
                        checked={allPayableSelected}
                        onChange={toggleAll}
                        disabled={payableRows.length === 0}
                        title='Select all unpaid invoices on this page'
                        className='w-4 h-4 accent-[#E04343] cursor-pointer disabled:cursor-not-allowed'
                      />
                    </th>
                  )}

                  <th scope="col" className="px-2 py-2">
                    S/N
                  </th>

                  <th scope="col" className="px-2 py-2">
                    Invoice ID
                  </th>

                  <th scope="col" className="px-2 py-2">
                    Shipment No
                  </th>
                  {/* <th scope="col" className="px-2 py-2">
                    Name
                  </th> */}
                  <th scope="col" className="px-2 py-2">
                    Email
                  </th>
                  <th scope="col" className="px-2 py-2">
                    Amount
                  </th>
                  <th scope="col" className="px-2 py-2">
                    Shipment Cost
                  </th>
                  <th scope="col" className="px-2 py-2">
                    Customer Type
                  </th>
                  <th scope="col" className="px-2 py-2">
                    Date
                  </th>
                  <th scope="col" className="px-4">
                    Status
                  </th>
                  {/* <th scope="col" className="px-2 py-2">
                    Action
                  </th> */}

                </tr>
              </thead>

              <tbody className=''>

                {
                  userLists?.data?.length > 0 ?
                    userLists?.data?.map(
                      (datas: any, index: any) => (
                        <tr className="bg-white  ">

                          {canMarkPaid && (
                            <td className="px-2 py-2">
                              <input
                                type="checkbox"
                                checked={selectedIds.includes(datas?.id)}
                                onChange={() => toggleRow(datas?.id)}
                                disabled={datas?.payment_status === 'successful'}
                                title={datas?.payment_status === 'successful' ? 'Already paid' : 'Select for manual payment'}
                                className='w-4 h-4 accent-[#E04343] cursor-pointer disabled:cursor-not-allowed disabled:opacity-40'
                              />
                            </td>
                          )}

                          <td className="px-2 py-2">
                            {index + 1}
                          </td>

                          <td className="px-2 ">
                            {datas?.invoice_id}
                          </td>
                          {/* The real waybill. `shipment_id` is the internal row id and
                              is only shown as a muted fallback so the row stays traceable. */}
                          <td className="px-2 ">
                            {datas?.shipment_number
                              ? datas.shipment_number
                              : <span className='text-[#B0B0B0]' title={`No waybill on record — internal id ${datas?.shipment_id}`}>—</span>}
                          </td>
                          {/* <td className="px-6 py-4 "> 
                            {datas?.email}
                          </td> */}
                          <td className="px-2 ">
                            {datas?.user_email}
                          </td>
                          <td className="px-2  ">
                            {(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format((datas?.amount) ? (datas?.amount) : 0.0))}
                            {/* An invoice at zero while the shipment holds a real price
                                means the invoice was never re-priced. Say so here rather
                                than leaving staff to discover it on a sent PDF. */}
                            {datas?.amount_mismatch && (
                              <p className='text-[10px] text-[#E04343] font-medium' title='This invoice does not match the price stored on the shipment'>
                                does not match shipment
                              </p>
                            )}
                          </td>
                          <td className="px-2  ">
                            {datas?.shipment_freight_cost === null || datas?.shipment_freight_cost === undefined
                              ? <span className='text-[#B0B0B0]'>—</span>
                              : <span className={datas?.shipment_freight_cost > 0 ? '' : 'text-[#B0B0B0]'}>
                                  {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(datas.shipment_freight_cost)}
                                </span>}
                          </td>
                          <td className="px-2 ">
                            {datas?.customer_type}
                          </td>
                          <td className="px-2  ">
                            {convertUTCDateToLocalDate(datas?.created_at)}
                          </td>
                          <td className="px-2 ">

                            {datas?.payment_status == 'successful' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                            {/* Distinguishes a hand-marked settlement from a Paystack one */}
                            {datas?.payment_method === 'manual' && (
                              <p className='mt-1 text-[10px] text-[#808080]'
                                title={`${datas?.payment_channel || 'Manual'}${datas?.payment_reference ? ' · ' + datas.payment_reference : ''}${datas?.marked_paid_by ? ' · by ' + datas.marked_paid_by : ''}`}>
                                manual · {datas?.payment_channel || 'n/a'}
                              </p>
                            )}
                            {datas?.payment_status == 'pending' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#FF922B', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                            {datas?.payment_status == 'failed' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#E6BDFF', color: '#B24BF1', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                            {datas?.payment_status == 'Missed' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#CAD8FA', color: '#4979ED', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                            {datas?.Spayment_statustatus == 'Closed' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#CAD8FA', color: '#4979ED', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}

                          </td>



                          {/* <td className="px-6 py-4 cursor-pointer">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="24" height="24" rx="4" fill="#EBEBEB" />
                              <path d="M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z" fill="#3F83F8" />
                              <path d="M15.2536 9.30891C14.2289 8.60625 13.1323 8.25 11.9944 8.25C10.9704 8.25 9.97219 8.55469 9.02742 9.15187C8.07469 9.75539 7.1407 10.8516 6.375 12C6.99422 13.0312 7.84125 14.0916 8.72344 14.6995C9.73547 15.3966 10.8359 15.75 11.9944 15.75C13.1428 15.75 14.2409 15.3968 15.2592 14.7002C16.1557 14.0859 17.0088 13.027 17.625 12C17.0067 10.9821 16.1508 9.92437 15.2536 9.30891ZM12 14.25C11.555 14.25 11.12 14.118 10.75 13.8708C10.38 13.6236 10.0916 13.2722 9.92127 12.861C9.75097 12.4499 9.70642 11.9975 9.79323 11.561C9.88005 11.1246 10.0943 10.7237 10.409 10.409C10.7237 10.0943 11.1246 9.88005 11.561 9.79323C11.9975 9.70642 12.4499 9.75097 12.861 9.92127C13.2722 10.0916 13.6236 10.38 13.8708 10.75C14.118 11.12 14.25 11.555 14.25 12C14.2493 12.5965 14.012 13.1684 13.5902 13.5902C13.1684 14.012 12.5965 14.2493 12 14.25Z" fill="#3F83F8" />
                            </svg>
                          </td> */}




                        </tr>
                      )
                    )
                    :
                    <div className='flex justify-start mt-4'>
                      <td >No Record Found</td>
                    </div>


                }

              </tbody>

            </table>
          </div>
          <div className='m-4 flex justify-end mt-20'>
            {
              userLists?.links?.filter(((item: any, idx: any) => idx < 1000)).map(
                (datas: any, index: any) => (
                  <button onClick={() => paginator(datas?.label == 'Next &raquo;' ? datas?.url?.charAt(datas?.url?.length - 1) : (datas?.label === '&laquo; Previous') ? datas?.url?.charAt(datas?.url?.length - 1) : datas?.label)} disabled={datas?.active} className={'mx-1 py-1 px-2 ' + ((datas?.active == false || datas?.url == null) ? 'bg-gray-300 text-black ' : 'bg-[#E04343] text-white')}>
                    {datas?.label == '&laquo; Previous' ? '< Previous' : (datas?.label === 'Next &raquo;') ? 'Next  >' : datas?.label}
                  </button>
                )
              )
            }

          </div>
        </div>
      </div>



      <section>
        <Modal
          visible={invoiceModal}
          width="550"
          height="500"
          effect="fadeInUp"
          onClickAway={closeInvoiceModal}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">
              <span className="flex justify-between px-2 pt-1">
                <p className='mt-2 font-bold'>Generate Invoice</p>
                <p className="cursor-pointer font-bold" onClick={closeInvoiceModal}><SvgElement type={icontypesEnum.CANCEL} /></p>
              </span>

              <form onSubmit={generateInvoice}>
                <div className="flex flex-col lg:flex-row lg:justify-between max-w-screen-xl mx-auto  mt-5">
                  <div className="relative flex flex-col min-w-0 break-words w-full  ">
                    <div className="flex-auto   py-10 pt-0">
                      <div className="flex flex-wrap ">

                        <div className="lg:w-12/12 w-full lg:pr-4">
                          <div className="flex justify-between mb-3">
                            <label className="text-[#333333] text-[12px]">From</label>
                            <SvgElement type={icontypesEnum.QUESTIONMARK} />
                          </div>
                          <div className="relative mb-4">
                            <input type="date" onChange={e => setFromDate(e.target.value)} placeholder='' className=" border border-gray-300 text-gray-500 text-sm rounded-md block w-full pl-4 p-2  " required />
                          </div>
                        </div>

                        <div className="lg:w-12/12 w-full lg:pr-4">
                          <div className="flex justify-between mb-3">
                            <label className="text-[#333333] text-[12px]">To</label>
                            <SvgElement type={icontypesEnum.QUESTIONMARK} />
                          </div>
                          <div className="relative mb-4">
                            <input type="date" onChange={e => setToDate(e.target.value)} placeholder='' className=" border border-gray-300 text-gray-500 text-sm rounded-md block w-full pl-4 p-2  " required />
                          </div>
                        </div>

                        <div className="lg:w-12/12 w-full lg:pr-4">
                          <div className="flex justify-between mb-3">
                            <label className="text-[#333333] text-[12px] font-[400]">Email</label>
                            <SvgElement type={icontypesEnum.QUESTIONMARK} />
                          </div>
                          <div className="relative mb-4">
                            <input type="email" name="email" onChange={e => setUserEmail(e.target.value)} className=" border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2" placeholder="john@gmail.com" required />
                          </div>
                        </div>





                      </div>
                    </div>
                  </div>
                </div>



                {/* <div className="flex items-center mb-2 mt-4">
                    <input id="default-checkbox" type="checkbox" value="" className="w-4 h-4 text-blue-600 bg-gray-100 border-[#D1D1D1] rounded " />
                    <label htmlFor="default-checkbox" className="ml-3 text-sm font-medium text-[#333333]">I agree with <span className="text-[#E04343]">terms and conditins</span></label>
                  </div> */}

                {sentTo && (
                  <p className="mb-3 text-[12px] text-green-700 bg-green-50 border border-green-200 rounded-md px-3 py-2">
                    Invoice sent to <b>{sentTo}</b>. Download a copy for your records below.
                  </p>
                )}

                <div className="flex gap-3">
                  <button
                    type="submit"
                    disabled={sending}
                    className="flex-1 flex justify-center items-center gap-2 text-white bg-[#E04343] rounded-[30px] transition ease-out delay-300 py-[10px] px-[20px] font-[700] text-[14px] disabled:opacity-60"
                  >
                    <span>Send Invoice</span>
                    {sending && (
                      <Oval visible height="16" width="16" color="#ffffff" secondaryColor="#f9adad" ariaLabel="sending" />
                    )}
                  </button>

                  <button
                    type="button"
                    onClick={downloadInvoice}
                    disabled={downloading}
                    className="flex-1 flex justify-center items-center gap-2 text-[#E04343] bg-white border border-[#E04343] rounded-[30px] transition ease-out delay-300 py-[10px] px-[20px] font-[700] text-[14px] disabled:opacity-60"
                  >
                    <span>Download Invoice</span>
                    {downloading && (
                      <Oval visible height="16" width="16" color="#E04343" secondaryColor="#FCBF94" ariaLabel="downloading" />
                    )}
                  </button>
                </div>







              </form>



            </div>

          </div>
        </Modal>
      </section>

      <section>
        <Modal
          visible={markPaidModal}
          width="500"
          height="470"
          effect="fadeInUp"
          onClickAway={closeMarkPaidModal}
        >
          <div style={{ height: '100%', overflow: 'auto' }}>
            <div className="container bg-[#fff] rounded-lg p-2">
              <span className="flex justify-between px-2 pt-1">
                <p className='mt-2 font-bold'>Record Manual Payment</p>
                <p className="cursor-pointer font-bold" onClick={closeMarkPaidModal}><SvgElement type={icontypesEnum.CANCEL} /></p>
              </span>

              <form onSubmit={markSelectedAsPaid} className='px-4 pt-4 pb-2'>
                <div className='bg-[#FAFAFA] border border-gray-200 rounded-md p-3 mb-4 text-[13px]'>
                  Marking <b>{selectedIds.length}</b> invoice{selectedIds.length === 1 ? '' : 's'} totalling{' '}
                  <b>{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(selectedTotal)}</b> as paid.
                  <p className='text-[11px] text-[#808080] mt-1'>
                    The shipments these invoices bill for are marked paid, moved to <b>Verified</b> if they were still
                    in review, and pushed to GetOnline for a shipment number if they don't already have one. Invoices
                    already settled are skipped.
                  </p>
                </div>

                <div className='mb-4'>
                  <label className="block mb-2 text-[#333333] text-[12px]">Payment Channel <span className='text-red-600'>*</span></label>
                  <select
                    value={paymentChannel}
                    onChange={(e) => setPaymentChannel(e.target.value)}
                    required
                    className="border border-gray-300 text-gray-700 text-sm rounded-md block w-full p-2"
                  >
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Cash">Cash</option>
                    <option value="POS">POS</option>
                    <option value="Cheque">Cheque</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className='mb-4'>
                  <label className="block mb-2 text-[#333333] text-[12px]">Payment Reference</label>
                  <input
                    type="text"
                    value={paymentReference}
                    onChange={(e) => setPaymentReference(e.target.value)}
                    placeholder='Teller / transfer reference (optional)'
                    className="border border-gray-300 text-gray-700 text-sm rounded-md block w-full p-2"
                  />
                </div>

                <div className='mb-4'>
                  <label className="block mb-2 text-[#333333] text-[12px]">Note</label>
                  <textarea
                    value={paymentNote}
                    onChange={(e) => setPaymentNote(e.target.value)}
                    rows={2}
                    placeholder='Anything the finance team should know (optional)'
                    className="border border-gray-300 text-gray-700 text-sm rounded-md block w-full p-2"
                  />
                </div>

                <button
                  type="submit"
                  disabled={marking}
                  className="flex justify-center items-center gap-2 text-white bg-[#E04343] rounded-[30px] w-full py-[10px] font-[700] text-[14px] disabled:opacity-60"
                >
                  <span>Confirm Payment</span>
                  {marking && <Oval visible height="16" width="16" color="#ffffff" secondaryColor="#f9adad" ariaLabel="saving" />}
                </button>
              </form>
            </div>
          </div>
        </Modal>
      </section>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />
    </>
  )
}

export default ManageInvoice